import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['list', 'item'];
  static values = { url: String };

  dragStart(event) {
    this.draggedItem = event.currentTarget;
    event.currentTarget.classList.add('opacity-50');
    event.dataTransfer.effectAllowed = 'move';
  }

  dragOver(event) {
    event.preventDefault();
    const target = event.currentTarget;
    if (target === this.draggedItem) return;

    const rect = target.getBoundingClientRect();
    const midY = rect.top + rect.height / 2;

    if (event.clientY < midY) {
      target.parentNode.insertBefore(this.draggedItem, target);
    } else {
      target.parentNode.insertBefore(this.draggedItem, target.nextSibling);
    }
  }

  async dragEnd(event) {
    event.currentTarget.classList.remove('opacity-50');
    await this.#persistOrder();
  }

  async #persistOrder() {
    const ids = this.itemTargets.map((el) => el.dataset.productId);

    const response = await fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || '',
      },
      body: JSON.stringify({ product_ids: ids }),
    });

    if (!response.ok) {
      console.error(`Reorder failed: ${response.status}`);
    }
  }
}
